import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import {
  HeaderConfig,
  appliedConfig,
  emailjsConfig,
} from "../config/commonConfig";
import WhatsAppButton from "./WhatsAppButton";

const Contact = () => {

  const form = useRef();
    const [sendingMail, setSendingMail] = useState(false);
  
    const sendEmail = (e) => {
      e.preventDefault();
      setSendingMail(true);
      emailjs
        .sendForm(
          emailjsConfig.serviceId,
          emailjsConfig.templateId,
          form.current,
          emailjsConfig.userId
        )
        .then(
          (result) => {
            document.getElementById("contact-form").reset();
            toast.success("Mensagem enviada com sucesso!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            console.log(result.text);
            setSendingMail(false);
          },
          (error) => {
            toast.error("Falha ao enviar a mensagem!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            console.log(error.text);
            setSendingMail(false);
          }
        );
    };

  return (
    <section
      id="contact"
      className={
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
        appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
          ? "bg-light"
          : ""
      }
    >
      <div className="row g-0">
        <div className="col-md-6 col-lg-7">
          <div className="section px-4 px-sm-5 mx-lg-5">
            <h2 className="fw-600 text-center mb-3">Contate-nos</h2>
            <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
            <p className="lead text-center mb-5">
              Envie sua mensagem e em até 24 horas responderemos.
            </p>
            <div class="mx-auto" style={{maxWidth: '550px'}}>
              <form id="contact-form" ref={form} onSubmit={sendEmail}>
              <div className="mb-3">
                <input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control border-2"
                  required
                  placeholder="Nome"
                />
              </div>
              <div className="mb-3">
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="form-control border-2"
                  required
                  placeholder="E-mail"
                />
              </div>
              <div className="mb-3">
                <textarea
                  id="form-message"
                  name="message"
                  className="form-control border-2"
                  rows={3}
                  required
                  placeholder="Mensagem..."
                  defaultValue={""}
                />
              </div>
              <p className="text-center mt-4 mb-0">
                <button
                  id="submit-btn"
                  className="btn btn-primary text-uppercase"
                  type="submit"
                >
                  {sendingMail ? (
                    <>
                      <span
                        role="status"
                        aria-hidden="true"
                        className="spinner-border spinner-border-sm align-self-center me-2"
                      ></span>
                      Enviado.....
                    </>
                  ) : (
                    <>{"Enviar Mensagem"}</>
                  )}
                </button>
              </p>
            </form>
            </div>
          </div>
        </div>
        <div
          className={
            "col-md-6 col-lg-5  " +
            (appliedConfig.appliedHeader === HeaderConfig.SideHeaderDark ||
            appliedConfig.appliedHeader === HeaderConfig.SideHeaderLight
              ? "bg-white"
              : "bg-light")
          }
        >
          <section className="section px-4 px-sm-5 mx-lg-4">
            <h2 className="fw-600 text-center mb-3">DADOS DE CONTATO:</h2>
            <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
            <div className="featured-box style-1">
              <div className="featured-box-icon text-6">
                {" "}
                <i className="fas fa-map-marker-alt" />
              </div>
              <h3>EAD Cursos de Trânsito.</h3>
              <p>
                Rua Urbano Borges Martins, 66, Lacustre - Castro/PR{" "}
              </p>
            </div>
            <div className="featured-box style-1">
              <div className="featured-box-icon text-6">
                {" "}
                <i className="fas fa-phone" />{" "}
              </div>
              <h3>Telefone</h3>
              <p>42.⁠ ⁠9.9937-5003</p>
            </div>
            <div className="featured-box style-1">
              <div className="featured-box-icon text-6">
                {" "}
                <i className="fas fa-envelope" />{" "}
              </div>
              <h3>E-mail</h3>
              <p>riobrancocursos@gmail.com</p>
            </div>
            <div className="featured-box style-1">
              <WhatsAppButton />
            </div>
            
          </section>
        </div>
      </div>
    </section>
  );
};

export default Contact;
